/* Blog-Artikel: füllt die leeren Produktkarten der früheren Blog-App (Bloggle) aus den Shopdaten.
   Handle: Attribut bggle-product-handle der Karte, sonst der Link /products/<handle>.
   Quelle: <routes.root>products/<handle>.js (Sprache/Markt der aktuellen Seite). Fehlendes Produkt: Karte ausgeblendet.
   Nur leere Karten werden befüllt; bereits gefüllte (App noch aktiv) bleiben unberührt. */
(function () {
  'use strict';
  var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var cards = document.querySelectorAll('.bggle_product-container');
  if (!cards.length) return;
  var cache = {};

  function handleOf(card) {
    var h = card.getAttribute('bggle-product-handle');
    if (h) return h;
    var a = card.querySelector('a[href*="/products/"]');
    var m = a && /\/products\/([^/?#]+)/.exec(a.getAttribute('href'));
    return m ? decodeURIComponent(m[1]) : '';
  }
  function isEmpty(card) {
    var t = card.querySelector('.bloggle_product--title');
    var img = card.querySelector('img.bloggle_product--img');
    return !!t && !t.textContent.trim() && (!img || !img.getAttribute('src'));
  }
  function money(cents) {
    if (typeof window.cryonosMoney === 'function') return window.cryonosMoney(cents);
    try { return new Intl.NumberFormat(document.documentElement.lang || 'en', { style: 'currency', currency: (window.Shopify && window.Shopify.currency && window.Shopify.currency.active) || 'EUR' }).format(cents / 100); }
    catch (e) { return (cents / 100).toFixed(2); }
  }
  function load(handle) {
    if (!cache[handle]) {
      cache[handle] = fetch(root + 'products/' + encodeURIComponent(handle) + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .catch(function () { return null; });
    }
    return cache[handle];
  }
  function sized(src) { return src + (src.indexOf('?') > -1 ? '&' : '?') + 'width=480'; }
  function hideCard(card) {
    card.hidden = true;
    card.style.display = 'none';
    var slider = card.parentElement;
    if (slider && !slider.querySelector('.bggle_product-container:not([hidden])')) {
      var wrap = slider.closest('.bggle_product-slider, .bggle_one-product') || slider;
      wrap.style.display = 'none';
    }
  }
  function fill(card, p) {
    if (!isEmpty(card)) return; // App war schneller
    var a = card.querySelector('a.bggle_button-link');
    if (a) a.setAttribute('href', root + 'products/' + p.handle);
    var img = card.querySelector('img.bloggle_product--img');
    var src = p.featured_image || (p.images && p.images[0]);
    if (img) {
      if (src) { img.src = sized(src); img.alt = p.title; img.loading = 'lazy'; } else { img.remove(); }
    }
    var t = card.querySelector('.bloggle_product--title');
    if (t) t.textContent = p.title;
    var pr = card.querySelector('.bloggle_product--price');
    var cur = card.querySelectorAll('.bloggle_product--price-currency');
    if (pr) pr.textContent = money(p.price);
    for (var i = 0; i < cur.length; i++) cur[i].textContent = '';
    var cmp = card.querySelector('.bloggle_product--compare-at-price');
    if (cmp && p.compare_at_price && p.compare_at_price > p.price) {
      cmp.textContent = money(p.compare_at_price);
      cmp.style.textDecoration = 'line-through';
    }
    card.setAttribute('data-kn-bc', '1');
  }

  Array.prototype.forEach.call(cards, function (card) {
    if (!isEmpty(card)) return;
    var handle = handleOf(card);
    if (!handle) { hideCard(card); return; }
    load(handle).then(function (p) {
      if (!isEmpty(card)) return;
      if (!p) hideCard(card); else fill(card, p);
    });
  });
})();
